export default __webpack_public_path__ + "static/media/warning--low-flying-aircraft--g1.28089b2a.png";